import { useMutation } from 'react-query';
import { updateDemandDraft } from 'src/services/api/demands';

function useUpdateDemandDraft() {
  return useMutation(({ demand, data }) => updateDemandDraft(demand, data));
}

export default useUpdateDemandDraft;
